export function checkErrorCode(errorCode) {
    switch (errorCode) {
        case '-1':
            console.warn('参数有误，请检查参数');
            break;
        case '-2':
            console.warn('所处APP没有权限，请联系JS API负责人打开');
            break;
        case '-3':
            console.warn('调用JS API页面所在域名没有权限，请联系JS API负责人打开');
            break;
        default:
            console.warn('调用JS返回', errorCode);
    }
}
export var AppJsApi = {
    QB: 'https://jsapi.qq.com/get?api=app.*,download.*',
    TBS: 'https://res.imtt.qq.com/tbs/tbs.js',
    // QQ: 'https://open.mobile.qq.com/sdk/qqapi.js?_bid=152',
    QQ: 'https://pub.idqqimg.com/qqmobile/qqapi.js?_bid=152',
    WX: 'https://res.wx.qq.com/open/js/jweixin-1.0.0.js',
    YYB: 'https://qzs.qq.com/open/yyb/common/js/jsbridge.js?_ck_bid=2&max_age=2592000',
    NEWS: 'https://mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1',
    KB: 'https://mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js',
    QZONE: 'https://qzonestyle.gtimg.cn/qzone/hybrid/lib/jsbridge.js',
    TV: '',
    WS: 'https://qzonestyle.gtimg.cn/qzone/hybrid/app/weishi/lib/wsapi.js',
};
